module.exports = __webpack_public_path__ + "static/media/DP_Embroidery_Necchi_Orange_Ind.Blue_White.4d093f5e.png";